import {ErrorEvent} from '../../../api/network';
import {
  IMCCreateChannelResponse,
  MCCreateChannelResponse,
  WebWidgetCreateResponse,
} from '../../../api/proto';
import i18n from '../../../i18n';
import getInstagramAuthError from '../platforms/Instagram/getInstagramAuthError';
import getTelegramBotAuthError from '../platforms/TelegramBot/getTelegramBotAuthError';
import getWebWidgetError from '../platforms/WebWidget/getWebWidgetError';
import getWhatsappAuthError from '../platforms/Whatsapp/getWhatsappAuthError';

export const getCreateChannelError = (res?: IMCCreateChannelResponse | null): ErrorEvent | null => {
  if (res?.telegramBotAuthFlow?.error) {
    return new ErrorEvent({
      message: getTelegramBotAuthError(res?.telegramBotAuthFlow?.error),
    });
  }

  if (res?.instagramAuthFlow?.status) {
    return new ErrorEvent({
      message: getInstagramAuthError(res?.instagramAuthFlow?.status),
    });
  }

  if (res?.whatsappAuthFlow?.status) {
    return new ErrorEvent({
      message: getWhatsappAuthError(res?.whatsappAuthFlow?.status),
    });
  }

  if (res?.webWidgetFlow && res?.webWidgetFlow?.result !== WebWidgetCreateResponse.Result.SUCCESS) {
    return new ErrorEvent({
      message: getWebWidgetError(res?.webWidgetFlow?.result),
    });
  }

  if (res?.result === MCCreateChannelResponse.Result.R_INTERNAL_SERVER_ERROR) {
    return new ErrorEvent({message: i18n.t('api_create_channel_internal_server_error')});
  }

  return null;
};

export default getCreateChannelError;
